import { Component, Input } from '@angular/core';

@Component({
    templateUrl: './home.template.html'
})

export class HomeComponent {
    title: string;
    subtitle: string;
    description: string;
    adminRoute: string;
    moduleRoutes: ModuleRoute[];

}

export class ModuleRoute {
    title: string;
    route: string;
    iconClass: string;
    description: string;
}